import authentication from "../authentication";
import axios from "../libs/axios";

export const RefreshToken = async () => {
  try {
    const res = await axios({
      url: `/member/api/login/refresh-token/member`,
      method: 'post',
      baseURL: process.env.REACT_APP_DOMAIN_MEMBER_BNET,
    })

    if (res && res.data) {
      authentication.set(res.data)
      return true
    }
    return false
  } catch (e: any) {
    // 네트워크 에러나 response가 없는 경우 처리
    if (!e.response) {
      console.warn('토큰 갱신 실패: 네트워크 에러 또는 응답 없음', e);
      return false;
    }

    const {data} = e.response;
    // 401 Unauthorized 에러인 경우에만 SSO 체크 페이지로 리다이렉트
    if (data?.status == 401 && data?.error == "Unauthorized") {
      const domain = process.env.REACT_APP_SSO_CHECK_PATH
      if (domain) {
        window.location.href = `${domain}?nextUrl=${window.btoa(window.location.href)}`
        // 리다이렉트 후 함수 종료 (Promise는 계속 pending 상태)
        return new Promise(() => {}); // 무한 대기하여 추가 실행 방지
      }
    }
    // 다른 에러는 로그만 남기고 false 반환
    console.warn('토큰 갱신 실패:', data);
    return false
  }
}